import { useEffect, useState, useRef, useDeferredValue } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';

import { searchQueryMinLength, status } from 'constants/general';
import {
  fetchEntityProviders,
  editProvider,
  removeEntityProvider as removeEntityProviderAction,
} from 'modules/categories/categoriesSlice';
import ProviderDiscountsComponent from 'modules/categories/providerDiscounts/components/ProviderDiscountsComponent';

// ###############################################################
// <------------------------ Constants -------------------------->
// ###############################################################
// ###############################################################
// <---------------------- End Constants ------------------------>
// ###############################################################
const ProviderDiscountsContainer = () => {
  // ###############################################################
  // <------------------------- Globals --------------------------->
  // ###############################################################
  const dispatch = useDispatch();
  const { healthPlanId } = useParams();
  // ###############################################################
  // <----------------------- End Globals ------------------------->
  // ###############################################################
  // ###############################################################
  // <------------------------ useState --------------------------->
  // ###############################################################
  const [searchQuery, setSearchQuery] = useState('');
  const InitialQueryString = {
    pageNumber: 1,
    pagesize: 10,
    healthPlanId,
    providerTypeIds: 6,
  };
  const [providersQueryString, setProvidersQueryString] = useState(InitialQueryString);
  const [isCreateProviderModalHidden, setIsCreateProviderModalHidden] = useState(true);
  const [entityProviderInfo, setEntityProviderInfo] = useState({});
  // ###############################################################
  // <---------------------- End useState ------------------------->
  // ###############################################################
  // ###############################################################
  // <------------------------ useEffect -------------------------->
  // ###############################################################
  const submitEntityProvider = useSelector(state => state.categories.submitEntityProvider);
  const editEntityProvider = useSelector(state => state.categories.editEntityProvider);
  const removeEntityProvider = useSelector(state => state.categories.removeEntityProvider);

  const prevSubmitEntityProvider = useDeferredValue(submitEntityProvider.status);
  const prevEditEntityProvider = useDeferredValue(editEntityProvider.status);
  const prevRemoveEntityProvider = useDeferredValue(removeEntityProvider.status);

  useEffect(() => {
    if (
      (status.SUCCESS === submitEntityProvider.status &&
        prevSubmitEntityProvider !== submitEntityProvider.status) ||
      (status.SUCCESS === editEntityProvider.status &&
        prevEditEntityProvider !== editEntityProvider.status) ||
      (status.SUCCESS === removeEntityProvider.status &&
        prevRemoveEntityProvider !== removeEntityProvider.status)
    ) {
      setProvidersQueryString({ ...InitialQueryString });
    }
  }, [submitEntityProvider.status, editEntityProvider.status, removeEntityProvider.status]);

  useEffect(() => {
    dispatch(fetchEntityProviders(providersQueryString));
  }, [dispatch, providersQueryString]);
  // ###############################################################
  // <---------------------- End useEffect ------------------------>
  // ###############################################################
  // ###############################################################
  // <--------------------- rest of hooks ------------------------->
  // ###############################################################
  const searchBarInputTimeout = useRef(null);
  // ###############################################################
  // <-------------------- End rest of hooks ---------------------->
  // ###############################################################
  // ###############################################################
  // <-------------------------- Logic ---------------------------->
  // ###############################################################
  // ###############################################################
  // <------------------------ End Logic -------------------------->
  // ###############################################################
  // ###############################################################
  // <------------------------- Actions --------------------------->
  // ###############################################################
  // ###############################################################
  // <----------------------- End Actions ------------------------->
  // ###############################################################
  // ###############################################################
  // <----------------------- UI Handlers ------------------------->
  // ###############################################################
  const handleSearchInputChange = (searchTerm, reset) => {
    const queryString = {
      ...providersQueryString,
      pageNumber: 1,
      isShowMore: false,
    };
    if (searchTerm) queryString.searchTerm = searchTerm;
    if (reset) delete queryString.searchTerm;

    setProvidersQueryString(queryString);
  };

  const handleSearchBarInputChange = event => {
    const { value } = event.target;

    if (value.length > 30) return;
    setSearchQuery(value);

    if (searchBarInputTimeout.current) clearTimeout(searchBarInputTimeout.current);

    if (value && value.length >= searchQueryMinLength) {
      searchBarInputTimeout.current = setTimeout(() => {
        clearTimeout(searchBarInputTimeout.current);

        handleSearchInputChange(value);
      }, 500);
    } else if (value.length < searchQueryMinLength && providersQueryString.searchTerm)
      handleSearchInputChange(value, true);
  };

  const handleShowMoreClick = () => {
    const data = {
      ...providersQueryString,
    };
    data.pageNumber += 1;
    data.isShowMore = true;
    setProvidersQueryString(data);
  };

  const handleAddProvider = () => {
    setIsCreateProviderModalHidden(false);
    setEntityProviderInfo({});
  };

  const handleEditProvider = providerData => {
    setIsCreateProviderModalHidden(false);
    setEntityProviderInfo(providerData);
  };

  const handleRemoveProvider = rowDataPayload => {
    const { providerKey } = rowDataPayload;

    const payload = {
      providerKey,
      data: {
        healthPlanId,
      },
    };
    dispatch(removeEntityProviderAction(payload));
  };
  // ###############################################################
  // <--------------------- End UI Handlers ----------------------->
  // ###############################################################
  // ###############################################################
  // <-------------------------- Render --------------------------->
  // ###############################################################
  // ###############################################################
  // <------------------------ End Render ------------------------->
  // ###############################################################
  // ###############################################################
  // <------------------------- Return UI ------------------------->
  // ###############################################################
  return (
    <ProviderDiscountsComponent
      entityProviderInfo={entityProviderInfo}
      isCreateProviderModalHidden={isCreateProviderModalHidden}
      setIsCreateProviderModalHidden={setIsCreateProviderModalHidden}
      searchQuery={searchQuery}
      handleSearchBarInputChange={handleSearchBarInputChange}
      providersQueryString={providersQueryString}
      handleShowMoreClick={handleShowMoreClick}
      handleAddProvider={handleAddProvider}
      handleEditProvider={handleEditProvider}
      handleRemoveProvider={handleRemoveProvider}
    />
  );
  // ###############################################################
  // <----------------------- End Return UI ----------------------->
  // ###############################################################
};

ProviderDiscountsContainer.propTypes = {};

ProviderDiscountsContainer.defaultProps = {};

export default ProviderDiscountsContainer;
